module.exports = "./assets/assets/代理协议模板.af3f30e1.docx";